module.exports = __webpack_public_path__ + "img/9.a3bd4462.jpg";